import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "v-shift" }
const _hoisted_2 = { class: "v-shift__header" }
const _hoisted_3 = { class: "v-shift__actions" }
const _hoisted_4 = { class: "v-shift__btn" }
const _hoisted_5 = { class: "v-shift__btn" }

import CommonButton from "@/components/common/CommonButton.vue";
import CommonSearch from "@/components/common/CommonSearch.vue";
import CommonTable from "@/components/common/CommonTable.vue";
import { useShiftStore } from "@/features/shifts/shifts.store";
import { IShiftTemplate } from "@/features/shifts/shifts.types";
import { Pencil02, Trash01, SearchMd, Plus } from "utruckin-icons";
import { onMounted, ref } from "vue";
import CommonDropdown from "@/components/common/CommonDropdown.vue";
import { useAppStore } from "@/store/app.store";
import { watch } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'ShiftView',
  setup(__props) {

const shiftStore = useShiftStore();
const appStore = useAppStore();

const loading = ref(false);
const shifts = ref<IShiftTemplate[]>([]);
const search = ref<string>("");

const getList = async () => {
  shifts.value = await shiftStore.getShifts(loading);
};

onMounted(() => {
  getList();
});

watch(
  () => appStore.refreshKey,
  () => {
    getList();
  },
  {
    immediate: false,
  }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(CommonSearch, {
        modelValue: search.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((search).value = $event)),
        icon: _unref(SearchMd),
        placeholder: 'Search',
        clearable: ""
      }, null, 8, ["modelValue", "icon"]),
      _createVNode(CommonButton, {
        type: "primary",
        label: "Add Shift",
        prepend: true,
        "prepend-icon": _unref(Plus)
      }, null, 8, ["prepend-icon"])
    ]),
    _createVNode(CommonTable, {
      headers: _unref(shiftStore).shiftHeaders,
      items: shifts.value,
      loading: loading.value
    }, {
      is_active: _withCtx(({ item }) => [
        _createElementVNode("span", {
          class: _normalizeClass(["v-shift__badge", item.is_active ? 'active' : 'inactive'])
        }, _toDisplayString(item.is_active ? "Active" : "Inactive"), 3)
      ]),
      kpi: _withCtx(() => [...(_cache[1] || (_cache[1] = [
        _createElementVNode("span", null, "—", -1)
      ]))]),
      kpi_progress: _withCtx(() => [...(_cache[2] || (_cache[2] = [
        _createElementVNode("span", null, "-", -1)
      ]))]),
      actions: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("button", _hoisted_4, [
            _createVNode(_unref(Pencil02), { size: 18 })
          ]),
          _createElementVNode("button", _hoisted_5, [
            _createVNode(_unref(Trash01), { size: 18 })
          ])
        ])
      ]),
      _: 1
    }, 8, ["headers", "items", "loading"])
  ]))
}
}

})